import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const CheckEmail = () => {
  const location = useLocation();
  const { email, message } = location.state || {};

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <img
            src={process.env.PUBLIC_URL + '/maincar.png'}
            alt="InternHub Logo"
            className="h-14 mb-2"
          />
          <span className="text-blue-600 text-3xl font-bold ml-2 self-center">InternHub</span>
        </div>
        <h2 className="mt-4 text-center text-3xl font-extrabold text-gray-900">Check your email</h2>
        <div className="mt-2 text-center text-sm text-gray-600">
          <p className="font-medium">
            {message || `We've sent a verification link to ${email || 'your email address'}`}
          </p>
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-xl">
        <div className="bg-white py-8 px-4 shadow-sm sm:rounded-lg sm:px-10">
          <div className="space-y-6">
            <div>
              <p className="text-sm text-gray-500">
                Please check your email and click the verification link to continue. The link will
                expire in 24 hours.
              </p>
            </div>

            <div>
              <p className="text-sm text-gray-500">
                Didn't receive the email? Check your spam folder or{' '}
                <Link to="/register" className="font-medium text-blue-600 hover:text-blue-500">
                  try again
                </Link>
              </p>
            </div>

            <div className="mt-6">
              <Link
                to="/login"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-xs text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Return to login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckEmail;
